import { useState } from 'react'

export default function useQueue () {
  const [queue, update] = useState([])

  return {
    current: queue[0],
    next: () => update(([_, ...rest]) => rest),
    push: (item) => update((queue) => [...queue, item]),
    concat: (items: unknown[]) => update((queue) => queue.concat(items)),
    clear: () => update([])
  }
}
